<template>

    <div class="container-wrapper">
        <div class="full-width">
            <edgesCards />

            <orderMapper />

            <div class="full-width grid grid-2">
                <shortUnitsTracker />
                <unitsTracker />
            </div>
        </div>
    </div>

</template>

<script>
import orderMapper from '../components/OrderMapper.vue'
import unitsTracker from '@/components/unitsTracker.vue'
import shortUnitsTracker from '../components/shortUnitsTracker.vue'
import edgesCards from '@/components/edgesCards.vue'

export default {
  name: 'ToolsView',
  components: { orderMapper, unitsTracker, shortUnitsTracker, edgesCards },
}
</script>

